/**************************************************
 * Nombre:       Nosotros_Certificados
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import {useEffect, useState} from "react";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";

const Nosotros_Certificados = () => {
    const [certificados, setCertificados] = useState([]);

    useEffect(() => {
        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({col: 'certificados', wheres: w}).then((dox) => {
            setCertificados(dox.data);
        })
    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography
                                sx={{
                                    color: theme.palette.primary.main,
                                    fontSize: 32,
                                    fontWeight: 800,
                                    textAlign: 'center',
                                    lineHeight: 1.2
                                }}>
                                Certificados y Registros
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 8, md: 6}} sx={{justifyContent: 'center', mt: 1}}>
                            <Typography
                                sx={{
                                    color: '#000',
                                    fontSize: 16,
                                    fontWeight: 300,
                                    textAlign: 'center',
                                    lineHeight: 1.2
                                }}>
                                Contamos con los certificados y registros que respaldan nuestro compromiso con la
                                calidad y la legalidad de cada servicio.
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 10}}>
                            <Grid
                                container
                                justifyContent={'center'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={6}
                            >

                                {certificados.map((it, index) => {
                                    return (
                                        <Grid container size={{xs: 6, sm: 4, md: 3}}

                                              sx={{
                                                  justifyContent: 'flex-start',
                                                  cursor: 'pointer',
                                                  backgroundImage: `url(${it.img})`,
                                                  backgroundSize: 'cover',
                                                  backgroundPosition: 'top',
                                                  height: 250,
                                              }}>
                                            <Zoom>
                                                <img src={it.img} style={{opacity: 0}} height={250}/>
                                            </Zoom>
                                        </Grid>
                                    )
                                })}

                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Nosotros_Certificados

const items = [
    'https://over-receptour.online/notis/recursos/17448155798711744815581.png',
    'https://over-receptour.online/notis/recursos/17462932907381746293295.png',
    'https://over-receptour.online/notis/recursos/17462932907381746293295.png',
    'https://over-receptour.online/notis/recursos/17477674721661747767475.png',
    'https://over-receptour.online/notis/recursos/17491429394371749142949.png',
    'https://over-receptour.online/notis/recursos/17491429394431749142944.png',
    'https://over-receptour.online/notis/recursos/17491429394451749142950.png',
    'https://over-receptour.online/notis/recursos/17497367223351749736725.png',
    'https://over-receptour.online/notis/recursos/17497367223461749736724.png',
    'https://over-receptour.online/notis/recursos/17497367223481749736725.png',
]